// pm-tools-mcp contract-v2 envelope types. See apps/pm-tools-mcp/src/.../contract.py.
//
// Every helper tool the model invokes returns an envelope with the same shape:
// metadata up top (title, freshness, source), an artifact_type tag plus the
// payload under `data`, optional warnings / pair-hints / links / structured-diff.

export type ArtifactType =
  | "html"
  | "table"
  | "markdown"
  | "json"
  | "text"
  | "evm-curve"
  | "gantt-data"
  | "criticality-curve"
  | "risk-heatmap"
  | "dependency-network"
  | "tree"
  | "wbs-tree"
  | "timeline"
  | "kpi-row"
  | "property-grid"
  | "header"
  | "container"
  | "tabs"
  | "split"
  | "image";

export type CanvasPane = "primary" | "secondary" | "inline-only";
export type Freshness = "live" | "stale" | "unknown";

export interface EnvelopeAudit {
  tool?: string;
  args?: Record<string, unknown>;
  produced_at?: string;
  freshness?: Freshness;
  git_sha?: string;
  project?: string;
}

export interface EnvelopeWarning {
  severity?: "info" | "warn" | "error";
  message: string;
  locus?: string;
}

export interface EnvelopeLink {
  href: string;
  label: string;
}

export interface EnvelopeRenderHints {
  canvas_pane?: CanvasPane;
  pairs_with?: string[];
}

export interface EnvelopeStructuredDiff {
  kind: string;
  file: string;
  section: string;
  before: unknown;
  after: unknown;
}

export interface HtmlData {
  url?: string;
  html?: string;
  source_path?: string;
}

export interface TableData {
  columns: string[];
  rows: Array<Record<string, unknown>>;
}

export interface ImageData {
  image_url?: string;
  image_base64?: string;
}

export interface Envelope {
  title: string;
  artifact_type: ArtifactType;
  data: unknown;
  audit?: EnvelopeAudit;
  warnings?: Array<string | EnvelopeWarning>;
  render_hints?: EnvelopeRenderHints;
  links?: EnvelopeLink[];
  structured_diff?: EnvelopeStructuredDiff;
}

export function envelopeTabId(env: Envelope): string {
  return `${env.audit?.tool ?? "unknown"}::${env.audit?.produced_at ?? Date.now()}`;
}
